import type { Subscriptions } from "./types";

import { getSubscription } from "./getters";

export const isAlreadySubscribed = (id: keyof Subscriptions) => getSubscription(id) !== undefined;
